/**
 * Model definition for Generic Comparison Price Priced
 */
export interface InternGenericComparisonPriced {
  __component: 'intern.generic-comparison-price-priced';
  id: string;
  headline: string;
  price: number;
  period: 'monthly' | 'yearly';
  highlighted: boolean;
}

export function isInternGenericComparisonPriced(obj: { __component?: string }): obj is InternGenericComparisonPriced {
  return obj.__component === 'intern.generic-comparison-price-priced';
}
